var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.746941 13.5481L6.24676 7.99254L0.74694 2.43701C0.615707 2.30445 0.511608 2.14708 0.440586 1.97388C0.369563 1.80067 0.333007 1.61504 0.333007 1.42757C0.333007 1.2401 0.369563 1.05446 0.440586 0.881261C0.511608 0.70806 0.615707 0.550684 0.74694 0.418122C0.878173 0.28556 1.03397 0.180408 1.20543 0.108666C1.3769 0.0369243 1.56067 -5.36629e-08 1.74626 -6.17753e-08C1.93185 -6.98878e-08 2.11563 0.0369243 2.28709 0.108666C2.45856 0.180408 2.61435 0.28556 2.74558 0.418122L9.25181 6.99025C9.38321 7.12272 9.48747 7.28006 9.5586 7.45327C9.62973 7.62649 9.66634 7.81217 9.66634 7.9997C9.66634 8.18722 9.62973 8.3729 9.5586 8.54612C9.48747 8.71933 9.38321 8.87668 9.25181 9.00914L2.74558 15.5813C2.61445 15.714 2.45868 15.8193 2.28721 15.8912C2.11573 15.963 1.93191 16 1.74626 16C1.56062 16 1.3768 15.963 1.20532 15.8912C1.03384 15.8193 0.878077 15.714 0.746941 15.5813C0.208299 15.0229 0.194124 14.1065 0.746941 13.5481Z",
    fill: "#888281"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShevronRight);
export default __webpack_public_path__ + "static/media/shevron-right.2453e094e7ee63102f28c6c20a635332.svg";
export { ForwardRef as ReactComponent };